module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10473/images/email-tracking-flow/sales-extension-review.png"